(() => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  let lastScrollY = Math.max(window.scrollY || 0, 0);
  let scrollDirection = lastScrollY > 92 ? 'down' : 'up';
  let ticking = false;

  const syncHeader = () => {
    const currentScrollY = Math.max(window.scrollY || 0, 0);
    const scrollDelta = currentScrollY - lastScrollY;

    if (Math.abs(scrollDelta) > 4) {
      scrollDirection = scrollDelta > 0 ? 'down' : 'up';
    }

    const isPastTop = currentScrollY > 18;
    const shouldCondense = currentScrollY > 92 && scrollDirection === 'down';
    header.classList.toggle('is-stuck', isPastTop);
    header.classList.toggle('is-condensed', shouldCondense);
    header.classList.toggle('is-expanded-on-scroll', isPastTop && !shouldCondense);
    header.dataset.scrollDirection = scrollDirection;
    lastScrollY = currentScrollY;
  };

  const requestHeaderSync = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      syncHeader();
      ticking = false;
    });
  };

  window.addEventListener('scroll', requestHeaderSync, { passive: true });
  window.addEventListener('resize', requestHeaderSync, { passive: true });
  syncHeader();
  window.setTimeout(syncHeader, 80);
})();
